export const GET_ALL_CASES = 'GET_ALL_CASES';
export const GET_ALL_CASES_SUCCESS = 'GET_ALL_CASES_SUCCESS';
export const GET_ALL_CASES_FAILED = 'GET_ALL_CASES_FAILED';

export const GET_RELATED_CASES = 'GET_RELATED_CASES';
export const GET_RELATED_CASES_SUCCESS = 'GET_RELATED_CASES_SUCCESS';
export const GET_RELATED_CASES_FAILED = 'GET_RELATED_CASES_FAILED';
